import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NotifyConfigs/Get`, payload),
    Edit: (payload) => Repository.post(`/api/NotifyConfigs/Edit`, payload),
}
